import { render, staticRenderFns } from "./UpgradeTicketForm.vue?vue&type=template&id=6fa41120"
import script from "./UpgradeTicketForm.vue?vue&type=script&lang=js"
export * from "./UpgradeTicketForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports